import styled from "styled-components";
import {NEW_LIVE_CASINO_PAGE} from "../../../../themes/css-global-classes";

/**
 * After all banners will be replaced with ones of the same size remove this code
 * PC 1750 x 200 / Mobile 414 x 105
 * @deprecated
 */
export const TopBanner777Box = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: calc(250 / 1750 * 100%);
  
  .${NEW_LIVE_CASINO_PAGE} & {
    padding-bottom: calc(200 / 1690 * 100%);
  }
  
    
  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    padding-bottom: calc(215 / 1024 * 100%);
    
  }
  
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    padding-bottom: calc(155 / 414 * 100%);
    
    .${NEW_LIVE_CASINO_PAGE} & {
      padding-bottom: calc(77 / 375 * 100%);
    }
  }
 
`;